import React from "react";
import {useTranslation} from "react-i18next";
import "./style.scss";
import {useNavigate} from "react-router";
import {ReactComponent as ArrowIcon} from "../../assets/icons/arrow2.svg";
import orderStore from "../../stores/order";
import {observer} from "mobx-react";
import {ApiGeneral_ScanArrowDirection} from "../../@types/enums/styles";
import {getCurrency} from "../../helpers/ApiHelper";
import useLayoutStyles from "../../hooks/styles";

export interface FooterScanArticleProps {
    goNext: () => void;
}

const FooterScanArticle = ({goNext}: FooterScanArticleProps) => {
    const [t] = useTranslation();
    const navigate = useNavigate();
    const styles = useLayoutStyles();

    const goToPayment = () => {
        if (!orderStore.order.lines.length)
            return;

        navigate("/order");
    }

    const goBack = () => {
        navigate("/menu#ns");
    }

    return <>
        <div className="FooterScanArticleSpace" />
        <div className="FooterScanArticle">
            <div className="buttons">
                <div className="button" onClick={goBack}>{t("back")}</div>
                <div className={`button payment ${orderStore.order.lines.length === 0 ? "disable" : ""}`} onClick={goToPayment}>
                    <div className="content">
                        {orderStore.order.lines.length > 0
                            ? <div className="count">
                                <div className="text">
                                    {orderStore.order.lines.length}
                                </div>
                            </div>
                            : <div/>
                        }
                        {t("viewOrder")}
                        <div className="price">
                            {orderStore.order.total > 0
                                ? `${orderStore.order.total.toFixed(2)} ${getCurrency()}`
                                : null
                            }
                        </div>
                    </div>
                </div>
            </div>
            {styles?.general.scannerArrowDirection === ApiGeneral_ScanArrowDirection.NO
                ? null
                : <div className="scan">
                        <div className="title">{t("scanQR")}</div>
                        <div className="description">{t("scanQRDescription")}</div>
                        <ArrowIcon className={`arrow ${styles?.general.scannerArrowDirection}`} />
                    </div>
            }
        </div>
    </>
}

export default observer(FooterScanArticle);
